<template>
<div>
  <h4 id="example-title" class="example-title">

    {{ heading }}

    <span class="text-small text-success copiedTxt" ref="copiedTxt">
      Copied
    </span>

  </h4>
  <div class="upload">
    
    <b-list-group class="m-b-20" v-if="files.length > 0">
      <b-list-group-item v-for="(file, index) in files" :key="file.id">
        <span>{{file.name}}</span> -
        <span v-if="file.error" class="badge-danger badge">{{file.error}}</span>
        <span v-else-if="file.success" class="badge-success badge">
          success
        </span>

           

        <span v-else-if="file.active" >
          <div class="loading">
              <div class="green-bar l1"></div>
              <div class="green-bar l2"></div>
              <div class="green-bar l3"></div>
              <div class="green-bar l4"></div>
              <div class="green-bar l5"></div>    
            </div>
        </span>
        <span v-else></span>

        <b-button type="button" variant="primary" size="xs" class="m-l-10" v-clipboard:copy="file.response.fileUrl" v-if="file.success" v-clipboard:success="onCopy">
          Copy
        </b-button>

      </b-list-group-item>
    </b-list-group>
    <p v-else class="text-danger">No files uploaded yet.</p>
    <div class="example-btn">

      <b-row>
        <b-col cols="12">

          <file-upload input-id="file2" class="btn btn-primary" :post-action="`${API_URL}attachable-files`"  :multiple="true"  v-model="files" @input-filter="inputFilter" @input-file="inputFile" :headers="{'x-access-token': token}" ref="upload" :data="{downloadable}">
            <i class="fa fa-plus"></i>
            Select files
          </file-upload>

         

          <button type="button" class="btn btn-success m-l-10" v-if="!$refs.upload || !$refs.upload.active" @click.prevent="$refs.upload.active = true">
            <i class="fa fa-arrow-up" aria-hidden="true"></i>
            Start Upload
          </button>
          <button type="button" class="btn btn-danger m-l-10" v-else @click.prevent="$refs.upload.active = false">
            <i class="fa fa-stop" aria-hidden="true"></i>
            Stop Upload
          </button>
          <b-form-checkbox v-model="downloadable" name="check-button" switch class="m-t-10">
            Downloadable Link
          </b-form-checkbox>
        </b-col>
        <b-col cols="12">
          <button class="btn btn-outline-danger float-right" type="button" @click="files = []">Clear All</button>
        </b-col>
      </b-row>

    </div>
  </div>

  

</div>
</template>

<script>
import FileUpload from 'vue-upload-component';

import {
  API_URL
} from '../../services/constants'
export default {
  props: ['heading'],
  data() {
    return {
      files: [],
      API_URL: API_URL,
      downloadable: true,
      token: JSON.parse(localStorage.getItem("user")).accessToken,
      uploadProgress: {
        file: '',
        progress: 0.00
      }
    }
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent()
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
        console.log('add', newFile)
      }
      if (newFile && oldFile) {
        // update
        console.log('Image File Upload', newFile)
        this.uploadProgress = {
           file: newFile.file.name,
           progress: parseFloat(newFile.progress)
        }
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    onCopy: function (e) {
      this.$refs.copiedTxt.classList.add("blink");

      // Code for Chrome, Safari and Opera
      this.$refs.copiedTxt.addEventListener("webkitAnimationEnd", this.removeCopied);

      // Standard syntax
      this.$refs.copiedTxt.addEventListener("animationend", this.removeCopied);

    },
    removeCopied() {
      this.$refs.copiedTxt.classList.remove("blink");
    }
  }
}
</script>

<style lang="scss" scoped>
.example-simple label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}

.copiedTxt {
  display: none;
  opacity: 1;
}

@keyframes blink {
  50% {
    opacity: 0.0;
  }
}

@-webkit-keyframes blink {
  50% {
    opacity: 0.0;
  }
}

.blink {
  display: inline-block;
  animation: blink 1s 0s 2;
  -webkit-animation: blink 1s 0s 2;
}

.loading {
  position: relative;
  width: 100px;
  height: 50px;
  z-index: 2;
}
.loading .green-bar {
  width: 4px;
  border-radius: 2px;
  position: absolute;
  animation-timing-function: ease;
  height: 4px;
  top: 0;
  z-index: 3;
  background-color: #2caaf6;
}
.loading .l1 {
  left: 0px;
  animation: l1-jump 2s infinite;  
  animation-delay: 0.1s;
}
.loading .l2 {
  left: 7px;
  animation: l2-jump 2s infinite;  
  animation-delay: 0.2s;
  opacity: 0.87;
}
.loading .l3 {
  left: 14px;
  animation: l3-jump 2s infinite;
  animation-delay: 0.1s;
  opacity: 0.74;
}
.loading .l4 {
  left: 21px;
  animation: l4-jump 2s infinite;  
  animation-delay: 0.15s;
  opacity: 0.62;
}
.loading .l5 {
  left: 28px;
  animation: l5-jump 2s infinite;  
  animation-delay: 0.0s;
  opacity: 0.5;
}
@-webkit-keyframes l1-jump {
  0% {
    top: 36px;
    height: 4px;
  }
  15% {
    top: 30px;
    height: 10px;
  }
  25% {
    top: 30px;
    height: 10px;
  }
  40% {
    top: 0px;
    height: 40px;
  }
  50% {
    top: 0px;
    height: 40px;
  }
  62% {
    top: 36px;
    height: 4px;
  }
  65% {
    top: 36px;
    height: 4px;
  }
  75% {
    top: 36px;
    height: 4px;
  }
  99% {
    top: 36px;
    height: 4px;    
  }
}

@-webkit-keyframes l2-jump {
  0% {
    top: 36px;
    height: 4px;
  }
  15% {
    top: 25px;
    height: 15px;
  }
  25% {
    top: 25px;
    height: 15px;
  }
  40% {
    top: 8px;
    height: 32px;
  }
  50% {
    top: 8px;
    height: 32px;
  }
  65% {
    top: 30px;
    height: 10px;
  }
  75% {
    top: 30px;
    height: 10px;
  }
  99% {
    top: 36px;
    height: 4px;    
  }
}


@-webkit-keyframes l3-jump {
  0% {
    top: 36px;
    height: 4px;
  }
  15% {
    top: 0px;
    height: 40px;
  }
  25% {
    top: 0px;
    height: 40px;
  }
  40% {
    top: 22px;
    height: 18px;
  }
  50% {
    top: 22px;
    height: 18px;
  }
  65% {
    top: 20px;
    height: 20px;
  }
  75% {
    top: 20px;
    height: 20px;
  }
  99% {
    top: 36px;
    height: 4px;    
  }
}

@-webkit-keyframes l4-jump {
  0% {
    top: 36px;
    height: 4px;
  }
  15% {
    top: 10px;
    height: 30px;
  }
  25% {
    top: 10px;
    height: 30px;
  }
  40% {
    top: 30px;
    height: 10px;
  }
  50% {
    top: 30px;
    height: 10px;
  }
  75% {
    top: 10px;
    height: 30px;
  }
  85% {
    top: 10px;
    height: 30px;
  }
  99% {
    top: 36px;
    height: 4px;    
  }
}


@-webkit-keyframes l5-jump {
  0% {
    top: 36px;
    height: 4px;
  }
  15% {
    top: 25px;
    height: 15px;
  }
  25% {
    top: 25px;
    height: 15px;
  }
  40% {
    top: 36px;
    height: 4px;
  }
  50% {
    top: 36px;
    height: 4px;
  }
  75% {
    top: 0px;
    height: 40px;
  }
  85% {
    top: 0px;
    height: 40px;
  }
  99% {
    top: 36px;
    height: 4px;    
  }
}


</style>
